import { UPDATE_TOKEN, UPDATE_RECAPTCHA, UPDATE_MAIL, UPDATE_PHONE, UPDATE_ALERT_SIGNIN } from '../types';


export function AuthReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_TOKEN:
            return {
                ...state,
                token: payload
            }
        case UPDATE_RECAPTCHA:
            return {
                ...state,
                isValidReCaptcha: payload
            }
        case UPDATE_MAIL:
            return {
                ...state,
                mail: payload
            }
        case UPDATE_PHONE:
            return {
                ...state,
                phone: payload
            }
        case UPDATE_ALERT_SIGNIN:
            return {
                ...state,
                alertSignIn: payload
            }
        default:
            break;
    }

} 